<template>
  <div id="app" class="app">
    <HeaderContainer
      :currentRoute="$route.name"
      />
    <router-view class="content" role="main"></router-view>
    <FooterContainer />
    <cookie-law
    theme="dark-lime"
    buttonText="Ich stimme zu"
    >
      <div slot="message">
        Diese Website verwendet Cookies – nähere Informationen dazu und zu Ihren Rechten als Benutzer finden
        Sie in unserer Datenschutzerklärung im <b-link :to="{name: 'legal-notice'}">Impressum</b-link>.
        Klicken Sie auf „Ich stimme zu“, um Cookies zu akzeptieren und direkt unsere Website besuchen zu können.
      </div>
    </cookie-law>
  </div>
</template>

<script>
import HeaderContainer from '@/views/containers/HeaderContainer.vue'
import FooterContainer from '@/views/containers/FooterContainer.vue'
import CookieLaw from 'vue-cookie-law'

import * as Cookie from 'tiny-cookie'

export default {
  name: 'app',
  components: {
    HeaderContainer,
    FooterContainer,
    CookieLaw
  },
  data() {
    return {
      supportsLocalStorage: true
    }
  },
  created() {
    // if (this.storageType === STORAGE_TYPES.local) {
    //   // Check for availability of localStorage
    //   try {
    //     const test = '__vue-cookielaw-check-localStorage'
    //     window.localStorage.setItem(test, test)
    //     window.localStorage.removeItem(test)
    //   } catch (e) {
    //     console.info('Local storage is not supported, falling back to cookie use')
    //     this.supportsLocalStorage = false
    //   }
    // }
  },
  computed: {
    canUseLocalStorage () {
      return this.storageType === STORAGE_TYPES.local && this.supportsLocalStorage
    }
  },
  methods: {
    setVisited () {
      if (this.canUseLocalStorage) {
        localStorage.setItem("cookie:accepted", true)
      } else {
        Cookie.set("cookie:accepted", true)
      }
    },
    getVisited () {
      if (this.canUseLocalStorage) {
        return localStorage.getItem("cookie:accepted")
      } else {
        return Cookie.get("cookie:accepted")
      }
    },
  }
}
</script>

<style lang="scss">
.app {
  background-color: white;
  margin-bottom: 200px;
  overflow: hidden;
  min-height: 100vh;
  margin-left: auto;
  margin-right: auto;
  font-family: "Lucida Grande","Lucida Sans Unicode","Lucida Sans",Geneva,Arial,sans-serif!important;
  .material-icons {
    vertical-align: middle;
  }
  h2, h3, h4, h5, h6 {
    font-style: BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Open Sans","Helvetica Neue",sans-serif;
  }

  h1 {
    font-family: Georgia,Cambria,"Times New Roman",Times,serif;
  }

  .avatar-image {
    display: inline-block;
    vertical-align: middle;
    -webkit-border-radius: 100;
    border-radius: 100%;
  }

  .inner-section {
    max-width: $max-content-width;
    padding-left: 20px;
    padding-right: 20px;
    margin-right: auto;
    margin-left: auto;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .outer-section {
    max-width: $max-width;
    margin-top: 52px;
    margin: 0 auto;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .special-section {
    max-width: 100vw;
  }
  .btn, .btn-group {
    margin-right: 5px;
    margin-top: 6px;
    margin-bottom: 6px;
  }
  .form-row {
    .btn {
      margin: 0;
    }
  }
  .btn-group {
    .btn {
      margin: 0;
    }
  }
  .section {
    margin-top: 24px;
    margin-bottom: 24px;
  }
  .custom-file-input:lang(de) ~ .custom-file-label::after {
    content: 'Durchsuchen';
  }
  blockquote {
    border-left: 4px solid #DDD;
    padding: 0 15px;
    color: #777;
  }
  // For author and post page
  .banner {
    margin-bottom: 2rem;
    padding: 0 0 0 0;
  }
  .dark-banner {
    background-color: rgb(32, 52, 142);
    // background-color: #333;
    color: #fff;
    padding: 2rem 0;
  }
  table {
    margin: 20px auto;
    width: auto;
  }
  textarea {
    min-height: 200px
  }
  .Cookie {
    a:hover {
      color: #fff;
    }
  }
}
</style>
